import { Flex } from '@bfa/common-ui';
import Head from 'next/head';
import React from 'react';
import Error from '../../components/Error';
import Loading from '../../components/Loading';
import RefreshmentNotification from '../../components/Notification';
import withNotificationMessage from '../../utils/withNotificationMessage';
import AcquisitionLanding from './AcquisitionLanding';
import FaqSection from './components/FaqSection';
import SocialMediaSection from './components/SocialMediaSection';
import SubscribedLanding from './SubscribedLanding';
import useLandingPage from './useLandingPage';
var LandingPage = function () {
    var _a = useLandingPage(), error = _a.error, loading = _a.loading, userId = _a.userId, subscription = _a.subscription, currentStarterKit = _a.currentStarterKit, faqSectionContent = _a.faqSectionContent, socialMediaSectionContent = _a.socialMediaSectionContent, socialMediaSectionPosts = _a.socialMediaSectionPosts;
    if (loading) {
        return React.createElement(Loading, null);
    }
    if (error) {
        return React.createElement(Error, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Head, null,
            React.createElement("title", null, "Personalized Monthly Makeup & Beauty Sample Subscription | IPSY"),
            React.createElement("meta", { name: "description", content: ['Refreshments Description'].join(' ') })),
        React.createElement(RefreshmentNotification, null),
        React.createElement(Flex, { flexDirection: "column", justifyContent: "center", background: "white", "data-testid": "landing-page" },
            subscription ? (React.createElement(SubscribedLanding, null)) : (React.createElement(AcquisitionLanding, { userId: userId, currentStarterKit: currentStarterKit })),
            React.createElement(SocialMediaSection, { content: socialMediaSectionContent, posts: socialMediaSectionPosts }),
            React.createElement(FaqSection, { content: faqSectionContent }))));
};
export default withNotificationMessage(LandingPage);
